import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TenIcon from '../icon';
import TenRadio from '../radio';
import TenCheckbox from '../checkbox';
import classNames from 'classnames';
import domHelper from '../utils/dom-helper';

export default class ReactComponent extends Component {
  static propTypes = {
    selected: PropTypes.bool,
    active: PropTypes.bool,
    indeterminate: PropTypes.bool,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    showCheckbox: PropTypes.bool,
    showRadio: PropTypes.bool,
    suffixIcon: PropTypes.string,
    optionIndex: PropTypes.number,
    optionKeyCommand: PropTypes.func,
    optionClick: PropTypes.func,
    onSelect: PropTypes.func,
    onMouseOver: PropTypes.func,
    nodeModel: PropTypes.object,
  };

  static defaultProps = {};

  static contextTypes = {
    tenOptions: PropTypes.object,
    tenCascaderPanel: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
    };
    this.refCheckboxElem = null;
    this.refRadioElem = null;
  }
  componentDidMount() {
    const { tenOptions } = this.context;

    tenOptions.addOption(this.props);
  }

  componentWillUnmount() {
    const { tenOptions } = this.context;
    tenOptions.removeOption(this.props);
  }

  focus() {
    this.setState({
      focused: true,
    });
  }

  blur() {
    this.setState({
      focused: false,
    });
  }

  onClick = (e) => {
    const { tenOptions } = this.context;
    if (this.props.disabled) {
      return;
    }
    const nodeElem = e.target;
    if (domHelper.contains(this.refCheckboxElem, nodeElem) || domHelper.contains(this.refRadioElem, nodeElem)) {
      return;
    }
    this.props.optionClick();
    tenOptions.onFocusOptionChange(this);
  };

  onKeyDown(e) {
    const { optionKeyCommand } = this.props;
    const { keyCode } = e;

    switch (keyCode) {
      case 13:
        optionKeyCommand('enter');
        break;

      case 37:
        // left
        optionKeyCommand('left');
        break;

      case 39:
        // right
        optionKeyCommand('right');
        break;

      default:
        break;
    }
  }

  _focused() {
    const { tenOptions } = this.context;
    return tenOptions.state.focused && this.state.focused;
  }

  _suffixIcon() {
    if (this.props.loading) {
      return 'loading_gradient';
    }

    return this.props.suffixIcon;
  }

  onSelect() {
    const { disabled, nodeModel, onSelect } = this.props;

    if (disabled) {
      return;
    }
    onSelect(nodeModel);
  }

  onCheckboxChange = () => {
    this.onSelect();
  };

  render() {
    const { selected, active, disabled, indeterminate, children, showCheckbox, showRadio, onMouseOver } = this.props;
    const _suffixIcon = this._suffixIcon();
    const _focused = this._focused();
    const contentClass = classNames([
      'ten-option',
      {
        'ten-option--selected': selected,
        'ten-option--active': active,
        'ten-option--focused': _focused,
        'ten-option--disabled': disabled,
        'ten-option--visible': this.visible,
      },
    ]);
    return (
      <div onClick={this.onClick} onMouseEnter={onMouseOver} className={contentClass}>
        {showCheckbox ? (
          <div
            ref={(el) => {
              this.refCheckboxElem = el;
            }}
          >
            <TenCheckbox
              checked={selected}
              disabled={disabled}
              indeterminate={indeterminate}
              className="ten-option__check"
              onClick={this.onCheckboxChange}
            />
          </div>
        ) : null}
        {showRadio && !showCheckbox ? (
          <div
            ref={(el) => {
              this.refRadioElem = el;
            }}
          >
            <TenRadio
              className="ten-option__check"
              checked={selected}
              disabled={disabled}
              onClick={this.onCheckboxChange}
            />
          </div>
        ) : null}
        <p className="ten-option__content">{children}</p>
        {_suffixIcon ? <TenIcon type={_suffixIcon} className="ten-option__suffix-icon" /> : null}
      </div>
    );
  }
}
